import React from 'react';
import { Link } from 'react-router-dom';

const Help: React.FC = () => {
  return (
    <div className="container">
      <div className="header">
        <img className="wm-banner" src="/wm-banner.svg" alt="WM — In motion with me" />
        <h1>Help & Support</h1>
        <p>Quick guidance for pairing, streaming, and sharing your event.</p>
      </div>

      <div className="card" style={{ marginBottom: '1.5rem' }}>
        <h3>Common steps</h3>
        <ol style={{ marginLeft: '1.5rem', lineHeight: '2' }}>
          <li>Create an event and save the pairing code.</li>
          <li>Open the mobile app and pair with the code.</li>
          <li>Share the public event link with spectators.</li>
          <li>Start the activity on your watch.</li>
        </ol>
      </div>

      <div className="card" style={{ textAlign: 'center' }}>
        <h2 style={{ marginBottom: '1rem' }}>Ready to stream?</h2>
        <Link to="/create">
          <button className="button button-primary">Create New Event</button>
        </Link>
      </div>
    </div>
  );
};

export default Help;
